import { AppButton, AppTableImproved } from "@/shared/Components";
import { useContainerHeight } from "@/shared/hooks";
import { PlusIcon } from "@/shared/icons";
import type { ConnectionsTableData } from "../../model";
import { useConnectionsTable } from "../../lib";
import styles from "./styles.module.scss";

export const Desktop = () => {
  const { state, methods } = useConnectionsTable();

  const { openCreateModal, handleClickRow } = methods;
  const { isLoading, tableColumns, tableData, rowSelection } = state;
  const { containerRef, containerHeight } = useContainerHeight();

  return (
    <div className={styles["connection-table-root"]} ref={containerRef}>
      <div
        style={{ height: `${containerHeight}px`, overflow: "hidden" }}
        className={styles["connection-table-wrapper"]}
      >
        <AppTableImproved<ConnectionsTableData>
          loading={isLoading}
          className={styles["connection-table"]}
          columns={tableColumns}
          dataSource={tableData}
          rowClassName={styles["row"]}
          rowSelection={rowSelection}
          scroll={{ y: containerHeight - 50, x: "max-content" }}
          virtual
          onRow={(row) => ({
            onClick: () => handleClickRow(row),
          })}
          isPaginationVisible={false}
          rowKey={(row) => row.id}
        />
        <div className={styles["create-button"]}>
          <AppButton onClick={openCreateModal} type="primary" className={styles.float}>
            <PlusIcon className={styles.icon} />
          </AppButton>
        </div>
      </div>
    </div>
  );
};
